export const isDesktop = false

export const platForm = isDesktop ? "desktop" : "web";